import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";

export default function PlanningYear() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });

  useEffect(() => { api.get("/config").then(r => setCfg(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/config", cfg);
      setMsg({ text: "Salvat", type: "success" }); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e) { setMsg({ text: e?.response?.data?.detail || "Eroare", type: "error" }); }
  };
  if (!cfg) return <div>Se încarcă...</div>;

  return (
    <>
      <PageHeader title="Anul de programare" subtitle="Aplicat global — rapoarte, campanii, sărbători legale"
        actions={<button className="btn btn-primary" onClick={save} data-testid="save-planning-year" {...lock(has("config.update"))}>Salvează</button>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 24 }}>
        <div style={{fontSize:12,color:"#64748B",marginBottom:8}}>Anul pentru care se programează CO în platformă. Folosit implicit în rapoarte, campanii, sărbători legale.</div>
        <input className="input" type="number" style={{maxWidth:200}} value={cfg.planning_year||new Date().getFullYear()} onChange={e=>setCfg({...cfg,planning_year:parseInt(e.target.value)||cfg.planning_year})} data-testid="cfg-planning-year" disabled={!has("config.update")} />
      </div>
    </>
  );
}
